import React, { useContext } from 'react'
import { RequestContext } from '../../context/RequestContext'
import { PersonalTrainerBooking } from '../index/service-category/personal-trainer/PersonalTrainerBooking'
import { TrainerCustomerReviews } from '../index/service-category/personal-trainer/TrainerCustomerReviews'
import { hasFeature } from '../../utils/markets'
import { useMarketBooking } from './MarketBooking'

// UAE / Malaysia wrappers around the Singapore personal trainer sections,
// wired to <MarketBooking> the way PersonalTrainer.js wires them on the SG page.

// Package selector (tier, 1-on-1 / partner, off-peak / peak) in the market's
// currency. Picking a package opens the booking form in the hero, as on the SG
// page, and preselects the package so the plan step prices it.
export const MarketPtPackages = ({ title, priceListHref, priceListLabel, note }) => {
    const { market, setIsQuickBook, openRequestForm } = useMarketBooking()
    const { setSelectedPackage } = useContext(RequestContext)
    return (
        <>
            <PersonalTrainerBooking
                market={market}
                title={title}
                year={new Date().getFullYear()}
                setIsQuickBook={setIsQuickBook}
                openRequestForm={openRequestForm}
                priceListHref={priceListHref}
                priceListLabel={priceListLabel}
                onSelectPackage={(pkg, tier) => setSelectedPackage({ ...pkg, tier })}
            />
            {note && (
                <div className="bg-slate-900 pb-8">
                    <p className="max-w-5xl mx-auto px-4 text-center text-sm text-amber-300/80">{note}</p>
                </div>
            )}
        </>
    )
}

// Reviews, behind the market's `reviews` switch (utils/markets.js).
export const MarketPtReviews = ({ testimonials, city }) => {
    const { market } = useMarketBooking()
    if (!hasFeature(market, 'reviews') || !testimonials?.length) return null
    return (
        <TrainerCustomerReviews
            testimonials={testimonials}
            title={`Personal Trainer Reviews${city ? ` - ${city.name}` : ''}`}
            showRating={hasFeature(market, 'googleRating')}
        />
    )
}
